import React from "react";
import MemberLink from "./MemberLink";

const ToolTipContent = ({toolTipInfo, paused_by}) => {
  return (
    <span className="ARStatusTextTooltip">
      {toolTipInfo.content}
      <MemberLink paused_by={paused_by}/>
    </span>
  );
};

export default ToolTipContent;